module.exports = __webpack_public_path__ + "static/media/twitter.084abcf7.jpg";